import { useMemo, memo, ReactNode, FC } from 'react';
import AgInfoCard from '../../Components/Cards/AgInfoCard';
import AgTypography from '../../Styles/AgTypography';
import { useIntl } from 'react-intl';
import * as S from './styled';
import { AgColor } from '../../../stories/Styles/AgColor';
import { useAppSelector } from '../../../redux/hooks';

interface CustomNoRowsOverlayProps {
  title?: string;
  description?: string;
  children?: ReactNode;
}

const CustomNoRowsOverlay: FC<CustomNoRowsOverlayProps> = ({
  title = 'WHY_NO_DATA',
  description = 'NO_DATA',
  children
}) => {
  const messages = useIntl().formatMessage;
  const helpLink = useAppSelector((state) => (state.language.helpLink));
  const infoCardContent = useMemo(() => (
    <AgTypography
      style={{
        display: 'grid',
        gap: '16px'
      }}
    >
      <AgTypography contentStyle={'AP.H5.Medium'} message={messages({ id: description || 'NO_DATA' })} />
      <AgTypography contentStyle={'AP.H5.Medium'} message={messages({ id: 'USE_BREADCRUMBS' })} />
      <AgTypography contentStyle={'AP.H5.Medium'}>
        {messages({ id: 'LEARN_MORE_IN' }, {
          learn: (
            <AgTypography
              component={'span'}
              contentStyle={'AP.H5.Medium'}
              style={{
                cursor: 'pointer'
              }}
              sx={{
                '&:hover': {
                  color: AgColor.primaryMain
                }
              }}
              onClick={() => { window.open(helpLink, '_blank'); }}
            >
              {<u>{messages({ id: 'HELP_DOC' })}</u>}
            </AgTypography>
          )
        })}
        {/* {messages({ id: 'HOMEPAGE_PARAGRAPH3' })} */}
      </AgTypography>
    </AgTypography>
  ), [helpLink, messages]);
  
  return (
    <S.Container>
      <AgInfoCard
        title={messages({ id: (title || 'WHY_NO_DATA') })}
        children={children || infoCardContent}
        closeIcon={false}
        width='560px'
      />
    </S.Container>
  );
};

export default memo(CustomNoRowsOverlay);
